module.exports = __webpack_public_path__ + "static/media/15-6.33200457.mp3";